import React from "react";

export default function EmptyState({ icon, title, subtitle, action }) {
  return (
    <div className="flex flex-col items-center justify-center text-center gap-2 py-16 px-6">
      {icon && (
        <div className="w-14 h-14 rounded-full bg-gray-50 flex items-center justify-center mb-1">
          {icon}
        </div>
      )}
      {title && <p className="font-semibold otaDark text-sm">{title}</p>}
      {subtitle && <p className="text-xs otaLight max-w-[240px]">{subtitle}</p>}
      {action && <div className="mt-3 w-full">{action}</div>}
    </div>
  );
}
